/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/gegen/"

const gegen: CommunityData = {
  code: "gegen",
  inviteCode: "gegen",
  name: "Gegen Berlin",
  thumbnail: "",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/gegen`,
  defaultCurrency: "EUR",
  socials: {},
  waitlist: false,
  styles: {
    comingSoon: {
      bgColor: "#000000",
      hero: {
        desktop: `${S3_PREFIX}web-background.mp4?type=video`,
        mobile: `${S3_PREFIX}web-background-mobile.mp4?type=video`,
        style: "bg-[#222222]",
      },
      logo: {
        desktop: `${S3_PREFIX}web-alternative-logo.png`,
        mobile: `${S3_PREFIX}web-alternative-logo.png`,
        style: "w-[92px] h-[48px] sm:w-[160px] sm:h-[85px]",
      },
      werzLogoColor: "#FFFFFF",
      title: "font-['BwGradualBold'] text-[28px] leading-[120%] text-[#bdbdbd]",
      text: "font-['BwGradualMedium'] text-[16px] leading-[100%] text-[#bdbdbd]",
      button:
        "font-['BwGradualBlack'] text-[14px] leading-[120%] uppercase p-4 bg-[#ffffff] text-[#222222] cursor-pointer w-fit",
      input: {
        base: "font-['BwGradualMedium'] text-[14px] leading-[120%] w-[256px] px-4 h-[48px] bg-[#222222] text-[#bdbdbd]",
        border: "#444444",
        borderFocus: "#6d6d6d",
        borderError: "#FF0000",
        errorText: "text-[#FF0000]",
      },
      error: "font-['BwGradualMedium'] text-[14px] leading-[120%] text-[#FF0000]",
      footerText: "font-['BwGradualMedium'] text-[14px] leading-[120%] text-[#6d6d6d]",
      skipButton:
        "font-['BwGradualMedium'] text-[14px] leading-[120%] text-[#6d6d6d] cursor-pointer",
      modal: {
        container: "bg-[#222222] px-[40px] py-[48px]",
        title: "font-['BwGradualBold'] text-[24px] leading-[120%] text-[#bdbdbd] text-center",
        text: "font-['BwGradualMedium'] text-[14px] leading-[120%] text-[#6d6d6d] text-center",
        width: "w-[358px]",
        otpInput:
          "!w-[40px] !h-[50px] rounded-[4px] text-[#bdbdbd] bg-[#000000] font-['BwGradualMedium'] text-[16px] leading-[120%] text-center",
        otpBorder: "#444444",
        otpBorderFocus: "#6d6d6d",
      },
    },
    global: {
      werzLogoColor: "#FFF",
      counterColor: "#FFF",
      logo: {
        src: "https://media.werz.at/community/icon/cmlzd2ny000009kvmqbonkmwk.jpg?uploadTime=1773594566555&type=image",
        styles: "w-[96px] h-[96px] object-contain",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[160px] h-[85px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#000000",
      asideBg: "#000000",
      asideStyles: "border-r border-[#6d6d6d]",
      contentBg: "",
      contentBoxShadow: "",
      bgDesktop: `${S3_PREFIX}web-background.mp4?type=video`,
      bgMobile: `${S3_PREFIX}web-background-mobile.mp4?type=video`,
      mainFont: "font-['BwGradualMedium']",
      primaryButton:
        "bg-[#ffffff] border border-[#ffffff] px-[18px] py-[18px] !text-[#222222] font-['BwGradualBlack'] !text-[16px] uppercase text-left",
    },
    navigation: {
      iconsColor: "#bdbdbd",
      sideBarSeparator: "border-r-[1px] border-[#222222]",
      separator: "border-[#222222]",
      item: "font-['BwGradualMedium'] text-[16px] text-[#bdbdbd] uppercase text-left gap-x-[10px] text-opacity-50 text-center border-b border-[#222222] !pl-0 !py-3",
      itemSelected: " !text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#000000] border border-[#444444] !pb-8",
      titles: "text-[#6d6d6d] font-['BwGradualBlack'] text-[40px] uppercase text-left",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#6d6d6d] font-['BwGradualMedium'] text-[14px] text-left",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#444444]",
        sectionTitle:
          "text-[#6d6d6d] font-['BwGradualBlack'] text-[40px] uppercase text-left pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#000000]",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full !aspect-square bg-gray-400",
          content: "flex flex-col py-4 bg-transparent",
          title: "text-[#bdbdbd] font-['BwGradualBold'] text-[16px] text-left leading-[120%]",
          subtitle: "text-[#6d6d6d] font-['BwGradualMedium'] text-[14px] text-left mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#444444]",
        sectionTitle:
          "text-[#6d6d6d] font-['BwGradualBlack'] text-[40px] uppercase text-left pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#000000]",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full !aspect-video bg-gray-400",
          content: "flex flex-col px-4 bg-transparent",
          title: "text-[#bdbdbd] font-['BwGradualBold'] text-[16px] text-left leading-[120%]",
          subtitle: "text-[#6d6d6d] font-['BwGradualMedium'] text-[12px] text-left mt-2",
          location: "text-[#6d6d6d] font-['BwGradualMedium'] text-[12px] text-left mt-1",
          date: "text-[#6d6d6d] font-['BwGradualMedium'] text-[12px] text-left mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title: "text-[#bdbdbd] font-['BwGradualBold'] text-[24px] text-left leading-[120%]",
        text: "text-[#bdbdbd] font-['BwGradualMedium'] text-[16px] text-left",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#6d6d6d] font-['BwGradualBlack'] text-[40px] uppercase text-left !mb-4 sm:mb-6",
      },
    },
    linktree: {
      bgDesktop: `${S3_PREFIX}web-background.mp4?type=video`,
      bgMobile: `${S3_PREFIX}mobile-landing-background.mp4?type=video`,
      bgMedia: "object-cover object-center",
      container:
        "flex flex-col items-center h-full w-full bg-center bg-cover bg-no-repeat min-h-screen relative bg-[#000000] px-4 py-12 sm:p-[64px]",
      communityInfo: {
        logo: "h-[128px] w-[128px] rounded-full border border-[2.5px] border-[#444444] object-cover",
        name: "text-[#ffffff] font-['BwGradualBold'] text-[26px] text-center leading-[120%] mt-4 mb-1",
        location:
          "text-[#bdbdbd] font-['BwGradualBold'] text-[20px] text-center leading-[120%] mb-2",
        description:
          "text-[#bdbdbd] font-['BwGradualMedium'] text-[16px] text-center mb-4 max-w-[500px]",
        socialMediaIconColor: "#bdbdbd",
        button:
          "bg-[#000000] border border-[#ffffff] px-[16px] py-[12px] text-[#ffffff] font-['BwGradualBlack'] text-[14px] uppercase text-left !w-fit cursor-pointer",
      },
      upcomingEvents: {
        loadingState:
          "mb-[32px] bg-[#000000] text-[#bdbdbd] font-['BwGradualMedium'] text-[16px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center border border-[#444444]",
        emptyState: {
          container:
            "sm:w-[500px] w-[95vw] bg-[#000000] border border-[#444444] flex flex-col justify-center items-center p-[34px] mb-[32px]",
          title:
            "text-[#bdbdbd] font-['BwGradualBold'] text-[20px] text-center leading-[120%] mb-1",
          text: "text-[#bdbdbd] font-['BwGradualMedium'] text-[16px] text-center",
          button:
            "bg-[#000000] border border-[#ffffff] px-[16px] py-[12px] text-[#ffffff] font-['BwGradualBlack'] text-[14px] uppercase text-left !w-fit cursor-pointer mt-4",
        },
        header:
          "text-[#ffffff] font-['BwGradualBold'] text-[20px] text-center leading-[120%] mb-[10px]",
        container: "sm:w-[500px] w-[95vw] gap-4 flex flex-col items-center overflow-hidden",
        collapsedEvent: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] bg-[#000000] border border-[#444444] flex justify-between",
          duration: "text-[#6d6d6d] font-['BwGradualMedium'] text-[12px] text-left",
          name: "text-[#bdbdbd] font-['BwGradualBold'] text-[20px] leading-[120%] one-line-truncate sm:w-[390px] w-[65vw]",
          plusIconColor: "#bdbdbd",
          media: "border border-[#444444] overflow-hidden m-2",
        },
        event: {
          container: "bg-[#000000] border border-[#444444] overflow-hidden sm:w-[500px] w-[95vw]",
          name: "text-[#bdbdbd] font-['BwGradualBold'] text-[20px] text-left leading-[120%] mb-1 one-line-truncate sm:w-[370px] w-[60vw]",
          startDate:
            "w-[68px] h-[68px] bg-[#ffffff] border border-[#ffffff] text-[#000000] flex flex-col justify-center items-center gap-1 font-['BwGradualBlack'] text-[18px]",
          duration: "text-[#6d6d6d] font-['BwGradualMedium'] text-[12px] text-left",
          location: "text-[#6d6d6d] font-['BwGradualMedium'] text-[12px] text-left",
          button:
            "bg-[#000000] border border-[#ffffff] px-[16px] py-[12px] text-[#ffffff] font-['BwGradualBlack'] text-[14px] uppercase text-left !w-fit cursor-pointer mt-3",
          product: {
            container:
              "min-h-[68px] border-t border-[#444444] px-4 py-3 flex justify-between gap-4",
            name: "text-[#bdbdbd] font-['BwGradualBold'] text-[16px] text-left leading-[120%] one-line-truncate sm:w-[390px] w-[65vw]",
            price: "text-[#bdbdbd] font-['BwGradualBold'] text-[16px] text-left leading-[120%]",
            link: "text-[#6d6d6d] font-['BwGradualMedium'] text-[12px] text-left",
            status: "text-[#bdbdbd] font-['BwGradualBold'] text-[16px] text-left leading-[120%]",
            button:
              "bg-[#000000] border border-[#ffffff] px-[16px] py-[12px] text-[#ffffff] font-['BwGradualBlack'] text-[14px] uppercase text-left !w-fit cursor-pointer",
          },
        },
        seeAllEvents:
          "text-[#bdbdbd] font-['BwGradualMedium'] text-[16px] text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      news: {
        loadingState:
          "mb-[32px] bg-[#000000] text-[#bdbdbd] font-['BwGradualMedium'] text-[16px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center border border-[#444444]",
        header:
          "text-[#ffffff] font-['BwGradualBold'] text-[20px] text-center leading-[120%] mb-[10px]",
        container: "flex flex-col gap-4",
        oneNews: {
          container:
            "h-[64px] cursor-pointer bg-[#000000] sm:w-[500px] w-[95vw] border border-[#444444] flex justify-between",
          name: "text-[#bdbdbd] font-['BwGradualBold'] text-[20px] leading-[120%] one-line-truncate sm:w-[390px] w-[65vw]",
          triangleIconColor: "#bdbdbd",
          created: "text-[#6d6d6d] font-['BwGradualMedium'] text-[14px] text-left",
          media: "border border-[#444444] overflow-hidden m-2",
        },
        seeAllNews:
          "text-[#bdbdbd] font-['BwGradualMedium'] text-[16px] text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      radioTracks: {
        loadingState:
          "mb-[32px] bg-[#000000] text-[#bdbdbd] font-['BwGradualMedium'] text-[16px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center border border-[#444444]",
        header:
          "text-[#ffffff] font-['BwGradualBold'] text-[20px] text-center leading-[120%] mb-[10px]",
        container: "flex flex-col gap-4",
        radioTrack: {
          container:
            "h-[64px] cursor-pointer bg-[#000000] sm:w-[500px] w-[95vw] border border-[#444444] flex justify-between",
          coverUrl: "border border-[#444444] overflow-hidden m-2",
          duration: "text-[#6d6d6d] font-['BwGradualMedium'] text-[14px] text-left",
          liveType: "text-[#bdbdbd] font-['BwGradualMedium'] text-[14px] text-left",
          liveTypeCircle: "w-2 h-2 bg-[#bdbdbd] rounded-full",
          playIconColor: "#000000",
          playIconBackgroundColor: "#ffffff",
          playIconBorderColor: "#000000",
          start: "text-[#6d6d6d] font-['BwGradualMedium'] text-[14px] text-left",
          title:
            "text-[#bdbdbd] font-['BwGradualBold'] text-[20px] leading-[120%] one-line-truncate sm:w-[390px] w-[65vw]",
        },
        seeAllTracks:
          "text-[#bdbdbd] font-['BwGradualMedium'] text-[16px] text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      otherLinks: {
        loadingState:
          "mb-[32px] bg-[#000000] text-[#bdbdbd] font-['BwGradualMedium'] text-[16px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center border border-[#444444]",
        header:
          "text-[#ffffff] font-['BwGradualBold'] text-[20px] text-center leading-[120%] mb-[10px]",
        container: "flex flex-col gap-[10px] mb-[40px]",
        link: {
          container:
            "h-[64px] cursor-pointer p-2 sm:w-[500px] bg-[#000000] w-[95vw] border border-[#444444] flex justify-between",
          name: "text-[#bdbdbd] font-['BwGradualBold'] text-[20px] leading-[120%]",
          triangleIconColor: "#bdbdbd",
          circleIcon: "ml-2 w-[24px] h-[24px] rounded-full border border-[#444444] object-cover",
        },
      },
      footer: {
        WERZlogoColor: "#ffffff",
        text: "text-[#6d6d6d] font-['BwGradualMedium'] text-[14px] text-center",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#000000] border border-[#444444] !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-[#444444]",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4",
        title: "text-[#bdbdbd] font-['BwGradualBold'] text-[26px] text-left leading-[120%]",
        subtitle: "text-[#6d6d6d] font-['BwGradualMedium'] text-[14px] text-left mb-4 mt-2",
        button:
          "bg-[#ffffff] border border-[#ffffff] px-[18px] py-[18px] !w-fit mb-4 sm:mb-0 text-[#222222] font-['BwGradualBlack'] !text-[16px] uppercase text-left",
        questions: "text-[14px] text-left leading-[130%] !text-[#6d6d6d]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#444444]",
        header: "text-[#bdbdbd] font-['BwGradualBold'] text-[24px] text-left leading-[120%]",
        text: "text-[#bdbdbd] font-['BwGradualMedium'] text-[14px] text-left mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#444444]",
        header: "text-[#bdbdbd] font-['BwGradualBold'] text-[24px] text-left leading-[120%]",
        text: "text-[#bdbdbd] font-['BwGradualMedium'] text-[14px] text-left mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden border border-[#6d6d6d] gap-y-[10px]",
        mapPinColor: "#000000",
        mapStrokeColor: "#00000000",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#bdbdbd] font-['BwGradualBold'] text-[24px] text-left leading-[120%]",
        text: "text-[#bdbdbd] font-['BwGradualMedium'] text-[14px] text-left",
      },
      tickets: {
        header:
          "text-[#bdbdbd] font-['BwGradualBold'] text-[24px] text-left leading-[120%] px-4 sm:px-8 pt-4 sm:pt-8 mb-2 sm:mb-4 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#000000] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#000000] border border-[#ffffff] px-[16px] py-[12px] text-[#ffffff] font-['BwGradualBlack'] text-[14px] uppercase text-left !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between leading-auto !bg-[#000000] border-b border-[#444444] py-4",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#bdbdbd] font-['BwGradualBold'] text-[16px] text-left leading-[120%] mb-1",
          description:
            "text-[#6d6d6d] font-['BwGradualMedium'] text-[14px] text-left mb-1 flex flex-row",
          price: "text-[#bdbdbd] font-['BwGradualBold'] text-[16px] text-left leading-[120%]",
          quantity: "text-[#ffffff] font-['BwGradualBlack'] text-[14px] uppercase text-left",
          status: "text-[#bdbdbd] font-['BwGradualBold'] text-[16px] text-left leading-[120%]",
          counterContainer:
            "bg-[#000000] border border-[#ffffff] px-[16px] py-[12px] gap-x-[16px] !w-fit !h-10",
          button:
            "bg-[#000000] border border-[#ffffff] px-[16px] py-[12px] text-[#ffffff] font-['BwGradualBlack'] text-[14px] uppercase text-left !w-fit",
          plusMinusColor: "#ffffff",
        },
      },
    },
  },
}

export default gegen
